import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ShareButton = (props) => {
  const { dataFancyboxTrigger, title, dataSource } = props;

  return (
    <button
      title={title}
      data-fancybox-trigger={dataFancyboxTrigger}
      data-fancybox
      data-src={dataSource}
      className="trainingContent__shareBtn"
    >
      <FontAwesomeIcon icon={['fas', 'share']} />
    </button>
  );
};

export default ShareButton;

ShareButton.propTypes = {
  dataFancyboxTrigger: PropTypes.string.isRequired,
  title: PropTypes.string,
  dataSource: PropTypes.string.isRequired,
};

ShareButton.defaultProps = {
  title: 'Share this Resource',
};
